export default __webpack_public_path__ + "scripts/resources/assignments/en/oracle-temp-2/assignment.json";